import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { IDateTimeWithZone } from '../../../common/date-time-with-zone.interface';
import { CalendarModule } from 'primeng/calendar';
import { format, parse, parseJSON } from 'date-fns';

@Component({
  selector: 'app-eca-date-picker',
  templateUrl: './eca-date-picker.component.html',
  styleUrls: ['./eca-date-picker.component.scss']
})

export class EcaDatePickerComponent implements OnInit {
  @Input() dateValue: IDateTimeWithZone; // the bound property must not be null
  @Input() isDisabled: boolean;
  @Input() popoverText: string;
  @Input() isRequired: boolean;
  @Input() controlId: string;
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() dateFormat = 'dd/mm/yy';
  @Input() placeholder: string = 'Select date';
  @Input() showButtonBar: boolean;
  @Input() label: string;
  @Input() isValid = true;
  @Input() validationMessage = '';
  @Output() dateValueChange: EventEmitter<IDateTimeWithZone> = new EventEmitter<IDateTimeWithZone>();

  @ViewChild('ecaDatePicker') datePicker: CalendarModule;

  constructor() {
  }

  ngOnInit(): void {
  }

  get selectedDate(): string {
    if (!this.dateValue?.dateTime) {
      return '';
    }

    try {
      if (typeof this.dateValue?.dateTime === 'string') {
        this.dateValue.dateTime = this.dateValue.dateTime.trim();
        // strip timezone to avoid hour changes
        if (this.dateValue.dateTime.endsWith('Z')) {
          this.dateValue.dateTime = this.dateValue.dateTime.substring(0, this.dateValue.dateTime.length - 1);
        }
        // treat the date now as an iso string without timezone...
        return format(parseJSON(this.dateValue.dateTime), 'dd/MM/yyyy');
      }
    } catch (ex) {
      try {
        return format(parse(this.dateValue.dateTime, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy');
      } catch (e) {
        return this.dateValue.dateTime;
      }
    }
  }

  set selectedDate(dateValue: string) {
    if (!dateValue) {
      this.dateValue.dateTime = '';
      return;
    }

    try {
      //const date = parse(dateValue, 'dd/MM/yyyy', new Date());
      const date = new Date(dateValue);
      this.dateValue.dateTime = format(date, 'yyyy-MM-dd');
    } catch (ex) {
      this.dateValue.dateTime = dateValue;
    }
  }

  selectedDateChanged() {
    this.dateValueChange.emit(this.dateValue);
  }
}
